// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../colors.css'","text-color-3":"#999999","notFound":"Dummy_notFound__3tf5v"};